import { ILoyaltyGenerateOtpMutationVariables, ServiceMode } from 'generated/graphql-gateway';
import { LoyaltyAppliedOffer } from 'state/loyalty/types';

export enum ShortCodeState {
  None = 'NONE',
  Pending = 'PENDING',
  Expired = 'EXPIRED',
  RequestError = 'REQUEST_ERROR',
  Claimed = 'CLAIMED',
  // Cart Offer Validation Error
  OfferValidationError = 'OFFER_VALIDATION_ERROR',
}

// Which backend the order selection behind a short code was actually created
// on. Persisted alongside the code (rather than recomputed live from
// flags/experiments) so polling always agrees with creation even if
// eligibility changes in between — see the comment on `handleOrderSelectionCreated`
// in use-short-code.ts for the race this avoids (BKPE-27933).
export type OrderSelectionBackend = 'legacy' | 'loyalty-service';

export interface IShortCodeData {
  shortCode?: string;
  expiry?: string;
  backend?: OrderSelectionBackend;
}

export interface IUserShortCode {
  shortCode?: string;
  shortCodeBackend: OrderSelectionBackend;
  shortCodeState: ShortCodeState;
  shortCodeLoading: boolean;
  getNewShortCode: (params: IGetNewShortCodeParams) => void;
  setShortCodeClaimed: () => void;
  setShortCodeExpired: () => void;
  resetShortCode: () => void;
}

export interface IGetNewShortCodeParams extends ILoyaltyGenerateOtpMutationVariables {
  serviceMode: ServiceMode | null;
  appliedOffers: LoyaltyAppliedOffer[];
}
